import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {USER_TABS} from 'src/constants';

import {UserRoleAuditLog} from './audit-log';
import {ADMIN_ROLE_SETTINGS_TABS} from './constants';
import {UserRoleSettings} from './user-role-settings';

type Props = {
    userId: number,
    accountId: number,
};

export const UserRoleSettingsPage = ({userId, accountId}: Props) => (
    <Routes>
        <Route
            path={`/${ADMIN_ROLE_SETTINGS_TABS.SETTINGS.name}`}
            element={<UserRoleSettings userId={userId} accountId={accountId}/>}
        />
        <Route path={`/${ADMIN_ROLE_SETTINGS_TABS.AUDIT_LOG.name}`} element={<UserRoleAuditLog userId={userId}/>}/>

        <Route
            path="*"
            element={(
                <Navigate to={
                    `/profile/user/${userId}/${USER_TABS.ROLE_SETTINGS.name}/${ADMIN_ROLE_SETTINGS_TABS.SETTINGS.name}`
                }
                />
            )}
        />
    </Routes>
);

